import { render, staticRenderFns } from "./app_global_snackbar.vue?vue&type=template&id=d99a0fae&scoped=true&"
import script from "./app_global_snackbar.vue?vue&type=script&lang=ts&"
export * from "./app_global_snackbar.vue?vue&type=script&lang=ts&"
import style0 from "./app_global_snackbar.vue?vue&type=style&index=0&id=d99a0fae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99a0fae",
  null
  
)

export default component.exports